import React from 'react';

import PolicyResult from 'components/atoms/policy_result';
import successIcon from 'assets/images/policy-result-success.svg';

const PolicySuccess: React.FC = () => (
  <PolicyResult
    variant="success"
    icon={<img src={successIcon} alt="" width="104" height="104" />}
    title="Apólice emitida com sucesso!"
    source="Tela Apólice Emitida ConlicitaSeg Only"
  >
    Em breve você irá receber um e-mail com sua apólice e o boleto de pagamento. Também pode
    conferir os detalhes da apólice <a href="/conlicitaseg">clicando aqui.</a>
  </PolicyResult>
);

export default PolicySuccess;
